import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ newPd: boolean }>`
  ${({ newPd }) =>
    newPd &&
    css`
      width: 100%;

      @media (min-width: 1680px) {
        width: 60%;
      }
    `}
`;

export const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 0.75rem 0;
`;

export const ErrorMessage = styled.span`
  font-size: 0.875rem;
`;

export const CollectReviewsWrapper = styled.div`
  margin-bottom: 1rem;

  display: flex;
  gap: 0.06rem;
  align-items: center;
`;

export const CollectReviewsLink = styled('a')`
  color: #404040;
  font-size: 0.75rem;

  &:hover {
    text-decoration: none;
    color: #000;
  }
`;
